export enum SectionType {
  Order = 'order',
  SendToDevice = 'send_to_device', // TODO Must be Camel case
  User = 'user',
  Address = 'address',
  Shipping = 'shipping',
  Coupons = 'coupons',
  Payment = 'payment',
  ChoosePayment = 'choosePayment',
  EditPayment = 'editPayment',
  ExpressChoosePayment = 'expressChoosePayment',
  ExpressPayment = 'expressPayment',
  Ocr = 'ocr',
}
